<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>智能人事</Breadcrumb-item>
        <Breadcrumb-item>员工关系</Breadcrumb-item>
        <Breadcrumb-item>离职管理</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <Alert type="warning" show-icon class="tip">
      数据从钉钉同步到本后台；确认离职仅更新本后台，不会触发钉钉确认离职。不含待退出企业与人才库。
    </Alert>
    
    <div class="search">
      <Form inline :label-width="60" :show-message="false">
        <Form-item label="状态">
          <Select v-model="query.status" style="width:140px;" clearable @on-change="search">
            <Option value="OPEN">办理中</Option>
            <Option value="DONE">已离职</Option>
            <Option value="CANCEL">已取消</Option>
          </Select>
        </Form-item>
        <Form-item label="关键字">
          <Input v-model="query.keyword" placeholder="姓名/钉钉ID" style="width:180px;" @on-enter="search"/>
        </Form-item>
        <Form-item>
          <Button type="primary" @click="search">查询</Button>
        </Form-item>
      </Form>
    </div>
    <div class="btn-wrap">
      <Button type="primary" :loading="syncing" @click="doSync">从钉钉同步</Button>
      <Button style="margin-left:8px;" type="error" @click="openSubmit">办理离职（仅本地）</Button>
    </div>
    <Table :columns="columns" :data="rows" :loading="loading" stripe no-data-text="暂无离职单"></Table>
    <div style="margin-top:12px;text-align:right;">
      <Page :total="total" :current="query.pageIndex" :page-size="query.pageSize"
            show-total @on-change="p => { query.pageIndex=p; load() }"/>
    </div>

    <Modal v-model="showSubmit" title="办理离职（仅本地）" @on-ok="submit">
      <Form :label-width="90">
        <Form-item label="员工姓名"><Input v-model="form.empName"/></Form-item>
        <Form-item label="钉钉userId"><Input v-model="form.dingUserId"/></Form-item>
        <Form-item label="离职原因"><Input v-model="form.reason" type="textarea"/></Form-item>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { resignationStatusText, sourceText } from './enumLabels'
export default {
  name: 'SmartHrResignation',
  data () {
    return {
      loading: false, syncing: false, showSubmit: false,
      rows: [], total: 0,
      query: { pageIndex: 1, pageSize: 20, status: '', keyword: '', processType: 'RESIGN' },
      form: { empName: '', dingUserId: '', reason: '' },
      columns: [
        { title: 'ID', key: 'id', width: 80 },
        { title: '员工', key: 'empName', minWidth: 120 },
        { title: '钉钉userId', key: 'dingUserId', minWidth: 140 },
        { title: '状态', key: 'status', width: 100,
          render: (h, { row }) => h('span', resignationStatusText(row.status)) },
        { title: '原因', key: 'reason', minWidth: 160 },
        { title: '来源', key: 'source', width: 90,
          render: (h, { row }) => h('span', sourceText(row.source)) },
        { title: '操作', width: 140,
          render: (h, { row }) => {
            if (row.status !== 'OPEN') return h('span', '-')
            return h('a', { on: { click: () => this.markDone(row) } }, '确认离职（本地）')
          }
        }
      ]
    }
  },
  created () { this.load() },
  methods: {
    stripReadonlyTimes (obj) {
      if (!obj || typeof obj !== 'object') return obj
      const payload = Object.assign({}, obj)
      delete payload.gmtCreate
      delete payload.gmtModified
      delete payload.syncedAt
      return payload
    },
    search () { this.query.pageIndex = 1; this.load() },
    load () {
      this.loading = true
      this.$http.post('/smartHr/process/page', this.query).then(res => {
        if (res && res.status === 'ok' && res.data) {
          this.rows = res.data.data || []
          this.total = res.data.totalCount || 0
        }
      }).finally(() => { this.loading = false })
    },
    doSync () {
      this.syncing = true
      this.$http.post('/smartHr/sync', { scope: 'resignation', mode: 'full' }).then(() => {
        this.$Message.success('已触发同步')
        this.load()
      }).finally(() => { this.syncing = false })
    },
    openSubmit () {
      this.form = { empName: '', dingUserId: '', reason: '' }
      this.showSubmit = true
    },
    submit () {
      const payload = this.stripReadonlyTimes(Object.assign({ processType: 'RESIGN', status: 'OPEN' }, this.form))
      this.$http.post('/smartHr/process/submit', payload).then(res => {
        if (res && res.status === 'ok') {
          this.$Message.success('已创建（仅本地）')
          this.showSubmit = false
          this.load()
        }
      })
    },
    markDone (row) {
      this.$Modal.confirm({
        title: '确认离职？',
        content: '仅更新本后台员工为已离职，不会写回钉钉。',
        onOk: () => {
          this.$http.post('/smartHr/process/update', { id: row.id, status: 'DONE' }).then(res => {
            if (res && res.status === 'ok') {
              this.$Message.success('已确认离职（本地）')
              this.load()
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.tip { margin-bottom: 12px; }
.btn-wrap {
  margin: 8px 0 12px;
  clear: both;
}
</style>



// WEBPACK FOOTER //
// SmartHrResignation.vue?07a79774